import * as React from 'react';
import styled from 'styled-components';
import { rem, darken } from 'polished';
import { IconImg } from '../../Defaults/Icon/IconImg';
import { FlexRow, FlexColCenter } from '../../Defaults/Flexbox/Flexbox';
import * as cartSrc from '../../../../assets/zemplin/cart-white.svg';
import * as arrowSrc from '../../../../assets/zemplin/arrow-triangle-white.svg';
import { Button } from '../../Zemplin/General/Button';
import { ZemplinLoaderWrapper } from '../../..';

interface Props {
  onButtonClick: any;
  onRequestClick: any;
  noStock?: boolean;
  isAddingToCart?: boolean;
}

function ButtonWithRequest({
  onButtonClick,
  onRequestClick,
  noStock,
  isAddingToCart,
}: Props) {
  const [isOpen, setIsOpen] = React.useState(false);
  const [isAdding, setIsAdding] = React.useState(false);
  const correctRotation = isOpen ? 180 : 0;

  React.useEffect(() => {
    if (!isAddingToCart) {
      setIsAdding(false);
    }
  }, [isAddingToCart]);

  const toggleOpen = e => {
    e.stopPropagation();
    if (!isAdding || isOpen) {
      setIsOpen(!isOpen);
    }
  };

  const handleRequestClick = e => {
    onRequestClick();
    setIsAdding(true);
    setIsOpen(false);
  };

  const handleButtonClick = e => {
    onButtonClick();
    setIsAdding(true);
    setIsOpen(false);
  };

  return (
    <Wrapper>
      <CartButton
        disabled={noStock || isAdding}
        type="button"
        onClick={handleButtonClick}
      >
        {isAdding ? (
          <Loader small={true} />
        ) : (
          <IconImg
            disabled={noStock}
            cursor={noStock ? 'inherit' : 'pointer'}
            src={cartSrc.toString()}
            alt="Pridať do košíka"
          />
        )}
      </CartButton>
      <DropdownArrow onClick={toggleOpen}>
        <IconImg
          cursor={'pointer'}
          rotate={correctRotation}
          src={arrowSrc.toString()}
          alt="Šípka"
          width={8}
          height={4}
        />
      </DropdownArrow>
      <RequestWrapper>
        {isOpen && (
          <DropdownWrapper type="button" onClick={handleRequestClick}>
            {'Dopytovať'}
          </DropdownWrapper>
        )}
      </RequestWrapper>
    </Wrapper>
  );
}

const Loader = styled.div<{ className?: string; small?: boolean }>`
  width: ${({ small }) => (small ? rem(20) : rem(50))};
  height: ${({ small }) => (small ? rem(20) : rem(50))};
  border: ${({ small }) =>
    small ? `${rem(4)} solid #f9f9f9` : `${rem(10)} solid #f9f9f9`};
  border-top: ${({ small, theme }) =>
    small
      ? `${rem(4)} solid ${theme.blogColors.primary}`
      : `${rem(10)} solid ${theme.blogColors.primary}`};
  margin: 0;
  border-radius: 50%;
  animation: spin 1.5s linear infinite;

  &.marginLeft {
    margin-left: ${rem(16)};
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

const Wrapper = styled(FlexRow)`
  justify-content: flex-end;
  margin-left: ${rem(8)};
  min-width: ${rem(64)};
`;

const RequestWrapper = styled.div`
  position: absolute;
`;

const CartButton = styled(Button)`
  background-color: ${({ theme }) => theme.colors.secondary};
  border-radius: ${rem(2)} 0px 0px ${rem(2)};
  padding: ${rem(12)};
  margin-right: ${rem(1)};
  width: ${rem(48)};

  &:hover {
    background-color: ${({ theme }) => darken(0.1, theme.colors.secondary)};
    transition: background-color 0.2s ease;
  }

  &:disabled {
    /* background-color: ${({ theme }) => theme.colors.disabled}; */
  }
`;

const DropdownArrow = styled(FlexColCenter)`
  padding: ${rem(22)} ${rem(8)};
  background-color: ${({ theme }) => theme.colors.secondary};
  border-radius: 0 ${rem(2)} ${rem(2)} 0;
  cursor: pointer;

  &:hover {
    background-color: ${({ theme }) => darken(0.1, theme.colors.secondary)};
    transition: background-color 0.2s ease;
  }
`;

const DropdownWrapper = styled(Button)`
  position: absolute;
  top: ${rem(49)};
  right: 0;
  background-color: ${({ theme }) => theme.colors.secondary};
  width: ${rem(160)};
  height: ${rem(48)};
  box-shadow: ${({ theme }) => theme.boxShadow.default};
  color: ${({ theme }) => theme.colors.white};
  font-size: ${rem(14)};
  line-height: ${rem(22)};
  border-radius: ${rem(2)};
  z-index: 1;

  &:hover {
    background-color: ${({ theme }) => darken(0.1, theme.colors.secondary)};
    transition: background-color 0.2s ease;
  }
`;

export { ButtonWithRequest };
